module.exports = __webpack_public_path__ + "img/Galaxy Digital.6b9ffac7.png";